import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import WaveSurfer from "wavesurfer";


class TtsTest extends Component {
  constructor() {
    super();
    this.state = {
      url: "",
      apiData: {},
      playerReady: false
    }
    this.languageList = [];
    this.wavesurfer = null;
  }

  componentDidMount() {
    var ttsdemoController = this;
    ttsdemoController.wavesurfer = WaveSurfer.create({
      container: "#waveform",
      waveColor: "gray",
      progressColor: "tomato",
      height: 100,
      cursorWidth: 1,
      cursorColor: "lightgray",
      barWidth: 1
    });

    ttsdemoController.wavesurfer.on("ready", () => {
      ttsdemoController.setState({ playerReady: true });
    });

    setTimeout(() => {
      ttsdemoController.loadLanguages();
    }, 300);
    document.addEventListener("projectChanged", function (event) {
      ttsdemoController.languageList = [];
      this.setState({ playerReady: false });
      ttsdemoController.wavesurfer.empty();
      document.getElementById("tts_text").value = "";
      ttsdemoController.projectId = event.projectId;
      ttsdemoController.loadLanguages(event.projectId);
    })
  }

  loadLanguages = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
          projectId = localStorage.getItem('currentProjectId');
      }
  }
    var ttsdemoController = this;
    ttsdemoController.languageList = [];
    $.ajax({
      url: "/api/project-languages-selected",
      async: false,
      method: 'GET',
      data: {
        projectId: projectId
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        'Content-Type': 'application/json'
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result.length !== 0) {
            ttsdemoController.languageList = res.result;
            ttsdemoController.setState(ttsdemoController.state);
          } else {
            ttsdemoController.NotifyNoLangSelected();
          }
        } else {
          ttsdemoController.NotifyFailToLoadLanguages(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  NotifyFailToLoadLanguages() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  NotifyNoLangSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
      position: "top-center"
    });
  }

  NotifyNotAdded(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }

  resetData = () => {
    document.getElementById("tts_text").value = "";
    this.state.playerReady = false;
    this.wavesurfer.empty();
    this.setState(this.state);
  }

  handleClickCopy = () => {
    var copyText = document.getElementById("transcript");
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("copy");
  }

  notifyNoInput() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not given any input</b>, {
      position: "top-center"
    });
  }

  notifyNoIndicLangSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
      position: "top-center"
    });
  }

  convertTextToSpeech = () => {
    var ttsComponent = this;
    if (document.getElementById("tts_text").value === "") {
      ttsComponent.notifyNoInput();
    } else if (document.getElementById("language").value === null) {
      ttsComponent.notifyNoIndicLangSelected();
    } else {
      var text = document.getElementById("tts_text").value;
      var lang = document.getElementById("language").value;

      ttsComponent.wavesurfer.load("/api/text-to-speech?projectId="
        + localStorage.getItem('currentProjectId') + "&text="
        + text + "&language=" + lang);
      // document.getElementById("audio").src = "/api/text-to-speech?projectId="
      //   + localStorage.getItem('currentProjectId') + "&text="
      //   + text + "&language=" + lang;
    }
  }

  playAudio = () => {
    var ttsComponent = this;
    ttsComponent.wavesurfer.play();
  }

  onChangeText = (e) => {
    document.getElementById("tts_text").value = e.target.value;
    this.state.playerReady = false;
    this.setState(this.state);
  }

  render() {
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={false}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />

        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
        {/* for reactToast */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/material.css" />
        <link rel="stylesheet" href="assets/css/buttonForm.css" />

        {/* Content Wrapper. Contains page content */}
        <div className="wrapper" style={{ height: "450px", backgroundColor: "#FFFFFF", overflow: 'hidden' }}>
          <ToastContainer className="Toast-at-center" />
          <div className="row">
            <div className="col-sm-3" style={{ marginTop: "30px", marginLeft: "20px" }}>
              <select id="language" onChange={this.transcriptFunc}
                style={{ width: '80%', height: '30px', borderRadius: '5px', background: 'white' }}>
                {this.languageList.map((language) =>
                  <option value={language.code}>{language.name}</option>
                )}
              </select>
            </div >
            <div className="col-sm-8" align="right" style={{ marginTop: "30px" }}>
              <button onClick={this.resetData} type="button" className="btn action-button">
                Reset
              </button>
              {/* <button className="btn action-button" title="copy content" onClick={this.handleClickCopy}><img src="./assets/images/copy.png" /></button> */}
            </div>
            <label style={{ marginLeft: "25px" }}>
              Try our TTS, by writing your text below
            </label>
          </div>
          <div className="row" style={{ marginTop: "70px" }}>
            <div className="col-md-4">
              <textarea
                placeholder='Write here'
                onChange={this.onChangeText}
                style={{
                  background: 'white', resize: 'none', minHeight: "200px", height: "80%", width: "100%",
                  fontSize: "14px", borderRadius: "10px", marginLeft: '60px'
                }}
                className="form-control"
                id="tts_text"
              />
            </div>
            <button className="btn2 table-action-button "
              style={{
                width: '70px', height: '36px', margin: '5% 5% 0px 10%',
              }}
              onClick={this.convertTextToSpeech}>Convert</button>
            <div className="col-md-5">
              <div id="waveform" style={{ marginTop: '5%' }}></div>
              <div align="center">
                <i class="fa fa-play" onClick={this.playAudio}
                  style={{
                    display: this.state.playerReady ? 'block' : 'none',
                    fontSize: "20px", width: '10%', border: '1px solid',
                    borderRadius: '10px', color: '#ffffff', cursor: 'pointer',
                    padding: '5px', background: '#282a65'
                  }}></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default TtsTest;


// WEBPACK FOOTER //
// ./src/ttsUi/TtsTest.js